<template>

  <v-card>

    <v-card class="text-center justify-center align-center mb-2" style="padding-bottom: 1em;" v-for="horaire in horaires" :key="horaire">
      <v-card elevation="4">
        <v-card-text style=" background-color: #9c8f69">
      <v-card-title style=" justify-content: center; font-weight: bold; font-size: 25pt" >{{ horaire }}</v-card-title>
          </v-card-text>
      <v-row class="text-center justify-center align-center mb-2 " style="padding-bottom: 1em; background-color: #d0e1ef;" v-for="category in categories" :key="category">

        <v-card-title  style=" justify-content: left; font-weight: bold; font-size: 20pt">{{ category }}</v-card-title>
        <div class="col-sm-3 mb-3" v-for="(row, index) in productRows" :key="index">
          <v-card elevation="4">
          <div v-for="product in row" :key="product.id">
            <v-col cols="auto">
            <div v-if="product.category === category && product.horaire === horaire">
              <Product :product="product" track-by="id"/>
            </div>
            </v-col>
          </div>
          </v-card>
        </div>

      </v-row>
      </v-card>
      </v-card>
  </v-card>
</template>

<script>
import Product from './Product'
import {mapActions, mapState} from 'vuex'
import chunk from 'chunk'

export default {
  name: 'ProductList',
  data: function () {
    return {
      categories: ['Menu principal', 'Fastfood', 'Extras', 'Boissons'],
      horaires: ['Déjeuner', 'Diner'],
    }
  },
  computed: mapState({
    productRows: state => chunk(state.products.all, 3)
  }),
  methods: mapActions([
    'getProducts'
  ]),
  components: {Product},
  created() {
    this.getProducts()
  }
}
</script>
